module.exports = __webpack_public_path__ + "img/7.28d14ddf.png";